import * as React from 'react';

interface Props {
	emptyRender: () => React.ReactNode;
	isRefetching?: boolean;
}

const EmptyWrapper: React.FC<Props> = ({ children, emptyRender, isRefetching }) => {
	return !isRefetching ? <>{React.Children.toArray(children)?.length > 0 ? children : emptyRender()}</> : null;
};

export default EmptyWrapper;
